import { render, staticRenderFns } from "./oops.vue?vue&type=template&id=dc8d77d6"
import script from "./oops.vue?vue&type=script&lang=js"
export * from "./oops.vue?vue&type=script&lang=js"
import style0 from "./oops.vue?vue&type=style&index=0&id=dc8d77d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports